module.exports = __webpack_public_path__ + "static/media/img_2.4fbe2b5c.png";